module.exports = __webpack_public_path__ + "static/media/Balon6Meses_BN_sq2.659f0167.jpg";